<template>
  <div></div>
</template>

<script>
import { getInfoByCode } from '../../api/api'

export default {
  name: 'ZhuaQiuIndex',
  data() {
    return {
      labelId: "",
      code: '',
      eno: process.env.ENV_NUM === '1' ? '138495222640' : '138603493800',
      originalLabelId: process.env.ENV_NUM === '1' ? 65 : 75
    }
  },
  methods: {
  },
  async mounted() {
    if (this.$route.query.c) {
      this.code = this.$route.query.c
    }
    const res = await getInfoByCode(this.code)
    if (res.data.code === "200" && res.data.data) {
      this.labelId = res.data.data.labelId || ''
      if (this.labelId === this.originalLabelId) {
        this.$router.push({
          path: '/magicstone',
          query: {
            eno: this.eno,
            c: this.code
          }
        })
      } else {
        this.$router.push({
          path: '/zhuaqiu/result',
          query: {
            eno: this.eno,
            c: this.code
          }
        })
      }
    } else {
      console.error('获取产品信息失败:', res.data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ZhuaQiu/Index.vue